angular.module('cfn').service('timeZoneHackService', [
  'dateFilter',
  function(dateFilter) {
    function getTimeDifferenceBetweenUTCAndGermany(date) {
      return (
        moment(date.getTime())
          .tz('Europe/Berlin')
          ._d.getTime() - date.getTime()
      );
    }

    function getTimeDifferenceBetweenUTCAndLocal(date) {
      return toFakeUTC(date) - new Date(date).getTime();
    }

    function toFakeUTC(date) {
      return moment.utc(dateFilter(date, 'yyyy-MM-ddTHH:mm')).valueOf();
    }

    function toBackendTimezone(date) {
      return toFakeUTC(date) - getTimeDifferenceBetweenUTCAndGermany(date);
    }

    function toClientTimezone(dateLong) {
      var dateMinusLocal =
        dateLong - getTimeDifferenceBetweenUTCAndLocal(dateLong);
      return moment(dateMinusLocal).tz('Europe/Berlin')._d;
    }

    return {
      toBackendTimezone: toBackendTimezone,
      toClientTimezone: toClientTimezone
    };
  }
]);
